import { Modal, Paper, Slide, useMediaQuery, useTheme } from '@material-ui/core'
import PolicyIcon from '@material-ui/icons/Policy'

import { getDirection } from '../../localization'
import { PolicyTable } from '../../types/cancelAndModifyPolicies'
import { sortPolicies } from '../PoliciesForm/policiesSorter'
import PoliciesActionRowMobile from './PoliciesActionRowMobile'
import RatePlansPoliciesActionModalRow from './RatePlansPoliciesActionModalRow'
import RatePlansPoliciesActionModalTableHead from './RatePlansPoliciesActionModalTableHead'
import useStyles from './styles/RatePlansPoliciesActionModal.styles'

interface RatePlansPoliciesActionModalProps {
  isOpen: boolean
  onClose: () => void
  data: PolicyTable[]
}
const RatePlansPoliciesActionModal: React.FC<
  RatePlansPoliciesActionModalProps
> = ({ isOpen, onClose, data }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide in={isOpen} direction="down">
        <Paper className={classes.paper}>
          <div>
            <PolicyIcon className={classes.icon} />
          </div>
          <div className={classes.tableRoot}>
            {isSmallScreen ? (
              sortPolicies(data).map((item) => (
                <PoliciesActionRowMobile
                  policiesData={item}
                  key={item.priority}
                />
              ))
            ) : (
              <>
                <div>
                  <RatePlansPoliciesActionModalTableHead />
                </div>
                <div>
                  {sortPolicies(data).map((item) => (
                    <RatePlansPoliciesActionModalRow
                      policiesData={item}
                      key={item.priority}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default RatePlansPoliciesActionModal
